export default __webpack_public_path__ + "assets/front/scss/editorial.755a8b8ac0972569e532ccf9035f5109.css";